import { DOMAttributes, PropsWithChildren } from 'react'

export type AdminProductButtonProps = PropsWithChildren<{
  onClick?: DOMAttributes<HTMLDivElement>['onClick']
  /**
   * Недоступное действие остаётся на своём месте погашенным, а не исчезает:
   * иначе число кнопок в строке меняется, колонка инструментов гуляет по
   * ширине и поля соседних строк разъезжаются.
   */
  disabled?: boolean
}>
export function AdminProductButton(props: AdminProductButtonProps) {
  return (
    <div
      onClick={props.disabled ? undefined : props.onClick}
      data-disabled={props.disabled ? 'true' : undefined}
      className="admin-btn flex items-center justify-center border border-accent rounded-lg cursor-pointer bg-back dark:bg-backDark"
      style={{
        width: '53px',
        height: '35px',
      }}
    >
      {props.children}
    </div>
  )
}
